<style scoped>
  .time{display: inline-block;line-height: 66px;padding: 0 24px;}
  .btn-default{font-size: 14px;color: #00a2e9;display: inline-block;vertical-align:middle}
  .search-button{background-color: #00a2e9;width: 28px;height: 28px;border-radius: 14px;position: absolute;top: 20px;text-align: center;right: 6px;cursor:pointer;}
  .search >>> .ivu-input{width: 400px;height: 36px;border-radius: 18px;font-size: 14px;color: #bbbbbb;padding: 0 30px 0 22px;}
  .list-panel{background-color: white;padding:0 40px}
</style>

<template>
  <div class="statistics">
    <Row>
      <Col span="24">
        <div style="height: 66px;background-color: #fff;padding: 0;">
          <div class="time">
            <div style="position: relative;display: inline-block;margin-left: 12px;">
              <Input class="search" placeholder="搜索关键词"></Input>
              <div class="search-button">
                <img style="margin-top: 6px;vertical-align: top;" src="/img/project/search-icon.png"/>
              </div>
            </div>
          </div>
          <div style="float: right;display: inline-block;line-height: 66px;margin-right: 40px;">
            <img style="margin: 0 10px;vertical-align:middle" src="/img/project/screen-icon.png"/>
            <p style="color: #6c767a" class="btn-default">筛选</p>
          </div>
        </div>
      </Col>
    </Row>
    <!---->
    <div class="list-panel">
      <Row style="height: 50px;line-height: 50px;font-size: 14px;color: #828fb1;border-bottom: 1px solid #eeeeee;text-indent: 2em;">
        <Col span="6">项目名称</Col>
        <Col span="9" style="text-align: center;">
          <Col span="8">项目状态</Col>
          <Col span="8">合同状态</Col>
          <Col span="8">合约期</Col>
        </Col>
        <Col span="9" style="text-align: center;">
          <Col span="8">合同金额</Col>
          <Col span="8">已收款</Col>
          <Col span="8">已开票</Col>
        </Col>
      </Row>
      <Row style="height: 50px;line-height: 50px;font-size: 14px;color: #464c5b;border-bottom: 1px solid #eeeeee;text-indent: 2em;" v-for="i in 5">
        <Col span="6">项目名称</Col>
        <Col span="9" style="text-align: center;">
          <Col span="8">项目状态</Col>
          <Col span="8">合同状态</Col>
          <Col span="8">合约期</Col>
        </Col>
        <Col span="9" style="text-align: center;">
          <Col span="8">0</Col>
          <Col span="8">0</Col>
          <Col span="8">0</Col>
        </Col>
      </Row>
      <Row>
        <Col span="24" style="margin:40px 0 57px 0;">
          <Page :total="100" show-elevator />
        </Col>
      </Row>
    </div>
  </div>
</template>

<script>
  export default {
    name: "statistics"//统计
  }
</script>
